// 德语----address
module.exports = {
  validate: {
    noEmail: "E-Mail darf nicht leer sein, bitte erneut eingeben",
    noPhone: "Die Telefonnummer darf nicht leer sein, bitte erneut eingeben",
    errorReg:
      "Die Eingabelänge beträgt 1-50 Ziffern, Sie können Groß- und Kleinbuchstaben, Zahlen, Symbole - . _ @ eingeben",
    noPassword: "Das Passwort darf nicht leer sein, bitte erneut eingeben",
    pwdReg:
      "Die Länge der Passworteingabe beträgt 8-32 Ziffern und muss Zahlen und Buchstaben enthalten",
    pwdCheck:
      "Die beiden eingegebenen Passwörter stimmen nicht überein, bitte erneut eingeben",
    pwdLengthReg:
      "Die Passwortlänge reicht von 8 bis 32, bitte bestätigen Sie die Eingabe",
    noCode: "Bitte Bestätigungscode eingeben",
    codeReg: "Bitte geben Sie einen 6-stelligen Bestätigungscode ein",
    nullText: "Die Eingabe darf nicht leer sein, bitte erneut eingeben",
    phoneCheck:
      "Die zweimal eingegebene Telefonnummer stimmt nicht überein, bitte erneut eingeben",
    emailNumReg:
      "Die E-Mail-Eingabelänge beträgt 6-50 Zeichen, bitte erneut eingeben",
    emailReg: "Falsche E-Mail-Adresse, bitte erneut eingeben",
    emailCheck:
      "Zweimal eingegebenes E-Mail-Konto ist inkonsistent, bitte erneut eingeben",
    noUsername:
      "Das Passwort darf die Kontonummer nicht enthalten, bitte erneut eingeben",
    accountReg: "Die Eingabe des Kontonamens ist falsch, bitte erneut eingeben",
  },
  area: {
    areaTitle: "Bereichsverwaltung",
    add: "Gebiet hinzufügen",
    area: "Bereich",
    addNextArea: "Neuen untergeordneten Bereich erstellen",
    areaNameTip: "Bitte geben Sie einen Regionsnamen ein",
    areaNameHold:
      "Die Eingabelänge beträgt 1-20 Ziffern, es können keine Sonderzeichen eingegeben werden",
    areaNumHold:
      "Die Eingabelänge beträgt 1-4 Ziffern, es können nur Zahlen eingegeben werden und der Zahlenbereich ist 0-9999",
    areaNumTip: "Bitte Bereichsnummer eingeben",
    areaName: "Bereichsname",
    checkAreaName: "Bereichsname darf nicht leer sein, bitte erneut eingeben",
    areaNameTip1: "Bereichsname darf nicht leer sein",
    areaNameTip2: "Falsche Bereichsnameneingabe, bitte neu eingeben",
    areaNum: "Bereichsnummer",
    checkAreaNum: "Gebiets - ID darf nicht leer sein,bitte erneut eingeben ",
    lastLevel: "Gehört zum gehobenen Bereich",
    checkLastLevel:
      "Der übergeordnete Bereich, zu dem es gehört, darf nicht leer sein, bitte erneut auswählen",
    lastLevelTip:
      "Bitte wählen Sie den übergeordneten Bereich aus, zu dem Sie gehören",
    delInfo:
      "Die Ausführung dieser Löschaufgabe löscht die Daten in diesem Bereich und kann nicht wiederhergestellt werden",
    oneStep: "Level eins",
    twoStep: "sekundär",
    threeStep: "Stufe 3",
    fourStep: "Level 4",
    fiveStep: "Level 5",
    delAreaTip:
      "Es gibt einen untergeordneten Bereich, der nicht gelöscht werden kann",
    personArea: "Die Person ist nicht an den Bereich gebunden",
    areaType: "Methode hinzufügen",
    addArea1: "Separat hinzufügen",
    addArea2: "kontinuierliche Zugabe",
    addArea3: "Matrixaddition",
    areaNameTop: "Präfix des Zonennamens",
    areaNameLast: "Zonennamensuffix",
    areaJoinHold: "Bitte geben Sie das Präfix des Domainnamens ein",
    areaJoinHold1: "Bitte geben Sie den Suffix des Gebietsnamens ein",
    startNum: "Startnummer",
    checkStartNum:
      "Die anfängliche Zahleneingabe ist falsch, bitte erneut eingeben",
    checkStartNum1:
      "Die Eingabe der Startnummer darf nicht leer sein, bitte erneut eingeben ",
    checkEndNum: "Die Eingabe der Endnummer ist falsch, bitte erneut eingeben",
    checkEndNum1: "Endnummer darf nicht leer sein, bitte neu eingeben",
    endNum: "Endnummer",
    topStart: "Kopfzeile Startnummer",
    checkTopStart:
      "Die Eingabe der ersten Startnummer ist falsch, bitte neu eingeben",
    checkTopStart1:
      "Die Eingabe der ersten Startnummer darf nicht leer sein, bitte erneut eingeben",
    topEnd: "Kopfzeilen-Endnummer",
    checkTopEnd:
      "Geben Sie die Endnummer der Kopfzeile falsch ein, bitte erneut eingeben",
    checkTopEnd1:
      "Die Eingabe der ersten Endnummer darf nicht leer sein, bitte neu eingeben",
    lastStart: "Heckstartnummer",
    checkLastStart:
      "Die Eingabe der Heckstartnummer ist falsch, bitte neu eingeben",
    checkLastStart1:
      "Geben Sie die Startnummer des Hecks ein. Sie darf nicht leer sein, bitte erneut eingeben",
    lastEnd: "Trail-Endnummer",
    checkLastEnd:
      "Die Endnummer des Endstücks ist falsch, bitte erneut eingeben",
    checkLastEnd1:
      "Die Eingabe der Endnummer darf nicht leer sein, bitte erneut eingeben",
    topTip:
      "Die Eingabelänge beträgt 1-2 Ziffern, es können nur Zahlen eingegeben werden und der Zahlenbereich ist 1-99",
    lastTip:
      "Die Eingabelänge beträgt 1-2 Ziffern, es können nur Zahlen eingegeben werden und der Zahlenbereich ist 1-99",
    areaNameTest: "Beispiel für Bereichsnamen",
  },
  addressBook: {
    config: "Projektkonfiguration",
    errorTip: "Fehler im Adressbuchformat",
    upgrade: "Adressbuch-Upgrade-Verwaltung",
    deviceIdTip: "Bitte geben Sie die Geräte-ID ein",
    deviceId: "Geräte ID",
    syncAll: "Alles synchroniesieren",
    sync: "Synchronisieren",
    sysVersion: "Aktuelle Version des Systemadressbuchs",
    deviceVersion: "Aktuelle Version des Geräteadressbuchs",
    syncTip: "Synchronbefehl erfolgreich ausgegeben",
  },
  newarea: {
    add: "Gebiet hinzufügen",
    edit: "Bereich bearbeiten",
    smallTip:
      "Aktuell kleinste Bereichsebene, es können keine weiteren Teilbereiche hinzugefügt werden",
    batch: "Batch-Add-Bereich",
    batch1: "kontinuierliche Zugabe",
    batch2: "Matrixaddition",
  },
  deviceSip: {
    saveTip:
      "Bitte das Adressbuch rechtzeitig exportieren, sonst werden alle Daten nach Verlassen der Seite gelöscht.",
    devMsg: "Geräteinformation",
    list: "Geräteliste",
    add: "Gerät hinzufügen",
    edit: "Gerät bearbeiten",
    batch: "Geräte stapelweise hinzufügen",
    areaChosen: "Auswahl auf Gebietsebene",
    areaNum: "Anzahl neu hinzugefügter Geräte in jedem Bereich",
    bacthTip:
      "Wenn die Bereichsebene als Gebäude ausgewählt ist und die Anzahl der neuen Geräte in jedem Bereich 4 beträgt, bedeutet dies, dass 4 Geräte in jedem erstellten Bereich hinzugefügt werden",
    note: "veranschaulichen",
    baseConfig: "Grundlegende Informationen Konfiguration",
    deviceName: "Gerätename",
    nameTip:
      "Behoben, dass dem Namen der Gruppe, zu der sie gehört, eine Nummer hinzugefügt wird, z. B. Gebäude 1-1",
    function: "Geräteunterstützungsfunktion",
    net: "Netzwerkkonfiguration",
    netType: "Netzwerkart",
    netTip1:
      "Statisch ist ein statisches Netzwerk, Sie müssen die IP und andere Informationen manuell festlegen.",
    netTip2:
      "DHCP ist ein dynamisches Netzwerk und Informationen wie IP werden automatisch vom Router zugewiesen.",
    mask: "Bitte geben Sie die Subnetzmaske ein",
    gateway: "Bitte betreten Sie das Tor",
    ip: "Bitte geben Sie die IP-Adresse ein",
    ipTip:
      "Die eingegebene IP-Adresse muss spezielle IP-Adressen wie 127.0.0.1 usw. vermeiden.",
    dns1: "Bitte DNS1 eingeben",
    dns2: "Bitte DNS2 eingeben",
    sip1: "sip1-Informationskonfiguration",
    config: "Informationskonfiguration",
    mode: "Modell",
    mode1: "Direktmodus",
    mode2: "Servermodus",
    user: "Bitte geben sie einen Benutzernamen ein",
    userTitle: "Nutzername",
    userTip:
      "Standardmäßig wird dem Gruppennamen eine Zahl hinzugefügt, z. B. 1-1-1",
    last: "Bitte geben Sie das Konto-Suffix ein",
    sipTip:
      "Bitte geben Sie den registrierten Benutzernamen und das Passwort des SIP-Servers ein",
    password: "Bitte geben Sie Ihr Passwort ein",
    passwordTitle: "Passwort",
    serverIp: "Bitte Server-IP eingeben",
    protocolType: "Bitte wählen Sie den Protokolltyp aus",
    protocolTypeTitle: "Art der Vereinbarung",
    sip2: "sip2-Informationskonfiguration",
    more: "Mehr",
    close: "Schließung",
    formatError: "Formatfehler, bitte neu eingeben",
    forbidTip: "Eingabe von 127.0.0.1 verboten, bitte erneut eingeben",
    call: "Anrufen und anrufen",
    monitor: "Monitor",
    lift: "Aufzugssteuerung",
    rtsp: "RTSP-Videostream",
    deviceTip:
      "Die Geräteunterstützungsfunktion darf nicht leer sein, bitte erneut wählen",
    maskTip1: "Die Subnetzmaske darf nicht leer sein, bitte erneut eingeben",
    maskTip2: "Das Format der Subnetzmaske ist falsch, bitte neu eingeben",
    gatewayTip1: "Gateway darf nicht leer sein, bitte erneut eingeben",
    gatewayTip2: "Gateway-Formatfehler, bitte erneut eingeben",
    ipTip1: "Die IP-Adresse darf nicht leer sein, bitte erneut eingeben",
    ipTip2:
      "Formatfehler der IP-Adresse, die Obergrenze ist 255.254.254.253, der erste Absatz ist nicht 0, bitte erneut eingeben",
    dns1Tip1: "DNS1 darf nicht leer sein,bitte erneut eingeben ",
    dns1Tip2: "DNS1-Formatfehler, bitte erneut eingeben",
    dns2Tip1: "DNS2-Formatfehler, bitte erneut eingeben",
    passwordTip1: "Das Passwort darf nicht leer sein, bitte erneut eingeben",
    serviceTip1: "serviceIp darf nicht leer sein, bitte erneut eingeben",
    serviceTip2: "formatfehler serviceIp, bitte erneut eingeben",
    sip2Tip:
      "Sie haben derzeit SIP2-Informationen konfiguriert, bitte vervollständigen Sie sie gemäß den Regeln",
    devnameTip1: "Der Gerätename darf nicht leer sein, bitte erneut eingeben",
    devnameTip2: "Formatfehler des Gerätenamens, bitte erneut eingeben",
    nameTip1: "Der Benutzername darf nicht leer sein, bitte erneut wählen",
    nameTip2: "Der Benutzername darf nicht leer sein, bitte erneut wählen",
    maxTip1:
      "Die Anzahl der Geräte im aktuellen Bereich hat die Obergrenze von 8 erreicht und es können keine weiteren hinzugefügt werden",
    area: "Bereich",
    editArea: "Bereich bearbeiten",
    addArea: "Gebiet hinzufügen",
    batchArea: "Batch-Add-Bereich",
    deleteArea: "Region löschen",
    areaName: "Bereichsname",
    areaNo: "Bereichsnummer",
    importAddr: "Adressbuch importieren",
    next: "Nächster Schritt",
    areaTip1: "Bitte zuerst den zu bearbeitenden Bereich auswählen",
    areaTip2: "Bitte zuerst den zu löschenden Bereich auswählen",
    areaTip3:
      "Ihr aktueller Bereich ist leer, Sie können derzeit keine Geräte in Stapeln hinzufügen, bitte fügen Sie zuerst Bereichsinformationen hinzu",
    noArea: "Noch keine Zonenkonfiguration",
    error: "Datenausnahme",
    addDevice: "Gerät hinzufügen",
    editDevice: "Gerät bearbeiten",
    delDevice: "Gerät löschen",
    batchDevice: "Geräte stapelweise hinzufügen",
    prev: "Vorherige",
    updateAddr: "Adressbuch des Geräts aktualisieren",
    saveAddr: "Adressbuch speichern",
    exportAddr: "Adressbuch exportieren",
    deleteTip: "Ob das Gerät gelöscht werden soll",
    deleteTip2:
      "Derzeit als Region ausgewählt, bitte zum Löschen zur Regionskonfiguration zurückkehren ",
    deleteTip3: "Bitte zuerst das zu löschende Gerät auswählen",
    deviceTip1: "Bitte wählen Sie zuerst das zu bearbeitende Gerät aus",
    deviceTip2:
      "Bitte wählen Sie zuerst die Region aus und fügen Sie dann das Gerät hinzu",
    exportSuccess: "Export erfolgreich",
    xmlTip: "Bitte laden Sie die XML-Datei des Adressbuchs hoch",
    xmlTip1: "Bitte wählen Sie die XML-Datei zum Hochladen aus",
    xmlTip2:
      "Das importierte Adressbuch stimmt nicht mit der aktuellen Community - Ebene überein und der Import ist fehlgeschlagen",
    areaConfig: "Bereichskonfiguration",
    deviceConfig: "Gerätekonfiguration",
    exportConfig: "Vorschau exportieren",
    projectConfig: "Projektkonfiguration",
    prevArea: "Gehört zum gehobenen Bereich",
    areaNoTip:
      "Die Startnummer ist größer als die Endnummer,  bitte erneut ausfüllen ",
    smallAreaTip:
      "Aktuell kleinste Bereichsebene, es können keine weiteren Teilbereiche hinzugefügt werden",
    areaNoTip1:
      "Die Startnummer des ersten Teils ist größer als die Endnummer des ersten Teils, bitte erneut ausfüllen",
    areaNoTip2:
      "Die Startnummer des Schwanzes ist größer als die Endnummer des Schwanzes, bitte erneut ausfüllen",
  },
  push: {
    list: "Push-Aufzeichnung",
    productType: "Produktnummer",
    softwareName: "Name der Software",
    versionNo: "Versionsnummer",
    time: "Push-Zeit",
    invalidTime: "Ablaufzeit",
    upgrade: "Aktualisierung",
    upgradeRecord: "Upgrade-Aufzeichnung anzeigen",
    deviceType: "Ausstattungsart",
    deviceName: "Gerätename",
    currentSoftName: "Aktueller Name der Gerätesoftware",
    currentSoftNo: "Aktuelle Geräteversionsnummer",
    upgradeNo: "Versionsnummer der Upgrade-Software",
    filterTip1: "Bitte geben Sie den Gerätenamen ein",
    filterTip2: "Bitte wählen Sie den Softwarenamen aus",
    filterTip3: "Bitte wählen Sie eine Versionsnummer",
    checkTip: "Häkchen aktivieren",
    ota: "OTA-Upgrade",
    taskName: "Missionsname",
    taskNameTip: "Bitte geben Sie einen Aufgabennamen ein",
    binName: "Firmware-Name",
    upgradeType: "Task-Upgrade-Methode",
    done: "Ob sofort auszuführen",
    upgradeTime: "Upgrade-Zeit",
  },
  check: {
    submit: "Herzlichen Glückwunsch, die Einreichung war erfolgreich!",
    noSubmit: "Hoppla, Übermittlung fehlgeschlagen!",
    file: "Dokument auswählen",
    noFile: "Keine Datei ausgewählt",
    projectName: "Projektname",
    projectNameTip: "Bitte geben Sie einen Projektnamen ein",
    describe: "beschreiben",
    contentTip: "Bitte Inhalt eingeben",
    areaType: "Regionshierarchie",
    example: "Zum Beispiel: Gebäudeeinheit-Raumnummer",
    areaTip: "Das Format der Bereichsnummer ist falsch, bitte neu eingeben",
    areaNameTip: "Bitte geben Sie einen Ebenennamen ein",
    nameTip: "Der Name darf nicht leer sein, bitte erneut eingeben",
    nameError: "Der Name wurde falsch eingegeben, bitte erneut eingeben",
    nameLength:
      "Die Länge der Namenseingabe beträgt 4~50, bitte erneut eingeben",
    areaNullTip: "Bereichsebene darf nicht leer sein",
    formateError:
      "Die Länge beträgt 1-6 Ziffern, es können keine Sonderzeichen eingegeben werden",
    noAreaTip: "Bereichsebene darf nicht leer sein, bitte erneut auswählen",
    maxFileTip: "Dateigröße überschreitet Limit",
    xmlTip: "Bitte laden Sie eine Datei im XML-Format hoch",
  },
  book: {
    areaBy: "Region",
    list: "Liste der doppelten Geräteinformationen",
    repeatTip:
      "Die folgenden Ausrüstungsinformationen werden dupliziert. Bitte ändern Sie die duplizierten Ausrüstungsinformationen. Nachdem Sie auf  Bestätigen geklickt haben, wird die Duplizierung der Ausrüstungseingabeinformationen beurteilt. ",
    coverTip:
      "Dieser Vorgang überschreibt die Batch-Hinzufügungsdaten der aktuell ausgewählten Ebene",
    batchTip:
      "Der IP-Bereich, der durch Hinzufügen von Geräten in Stapeln generiert wird",
  },
  updateNewSip: {
    otaDeleteTip:
      "Löschen fehlgeschlagen, nur nicht gestartete Aufgaben können gelöscht werden",
    deleteArea1: "Ob die Region gelöscht werden soll",
    deleteArea2:
      "Gleichzeitig werden alle Bereiche und Geräte unterhalb dieses Bereichs gemeinsam gelöscht",
    codeRepeatTip:
      "Die Regions-ID der gleichen Ebene kann nicht wiederholt werden, bitte geben Sie die aktuelle Regions-ID erneut ein",
    nameRepeatTip:
      "Bereichsnamen auf derselben Ebene können nicht dupliziert werden, bitte geben Sie den aktuellen Regionsnamen erneut ein",
    deviceIp: "Geräte-IP",
    callin: "Anrufen",
    callout: "ausatmen",
    systemMsg: "System Information",
    batchIpTip:
      "Der IP-Bereich, der diesmal durch das Hinzufügen von Geräten in Stapeln generiert wurde",
    ip: "IP Adresse",
    mask: "Subnetzmaske",
    gateway: "Tor",
    noData: "NEIN",
    noAddressTip:
      "Es gibt derzeit keine Adressbuchdaten, die synchronisiert werden können",
    operator: "Operator",
    goTip: "Klicken, um zum entsprechenden Schritt zu springen",
    deviceNameTip:
      "Die Eingabelänge beträgt 1-16 Ziffern, es können keine Sonderzeichen eingegeben werden",
    filter1: "Geben Sie einen Bereichsnamen zum Filtern ein",
    filter2: "Bereichsnamen oder Gerätenamen zum Filtern eingeben",
    secret: "Verschlüsselungskennwort",
    secretTip:
      "Bitte geben Sie ein Passwort mit maximal 32 Zeichen ein, das Format ist nicht begrenzt",
    noSecretTip: "Kein Verschlüsselungspasswort kann ignoriert werden",
    setSecret: "Kennwort für die Verschlüsselung des Adressbuchs festlegen",
    ignore: "Vernachlässigung",
    emptyBookTip:
      "Das Adressbuch ist leer und kann vorübergehend nicht exportiert werden",
    errorSecret:
      "Passwortfehler bei der Adressbuchverschlüsselung, bitte erneut eingeben",
    other: "andere",
    doorAuth: "Zugangskontrolle",
    funTitle:
      "Bitte überprüfen Sie die Funktionen, die von dem hinzugefügten Gerät unterstützt werden",
    callInTip: "Geräte-Support-Anruf",
    callOutTip: "Gerätesupport wird angerufen",
    monitorTip: "Das Gerät unterstützt die Überwachung",
    doorTip: "Das Gerät unterstützt die Entsperrfunktion",
    liftTip: "Geräteunterstützungssteuerung Aufzug",
    maskTip:
      "Bitte geben Sie die Subnetzmaske ein, Formatreferenz: 255.255.255.255",
    gatewayTip: "Bitte geben Sie das Gateway ein, Formatreferenz: 1.1.1.1",
    ip1: "Bitte geben Sie die IP-Adresse ein, Formatreferenz: 1.1.1.1",
    ipTip:
      "Die eingegebene IP-Adresse muss spezielle IP-Adressen wie 127.0.0.1 usw. vermeiden.",
    dns1: "Bitte DNS1 eingeben, Formatreferenz: 1.1.1.1",
    dns2: "Bitte DNS2 eingeben, Formatreferenz: 1.1.1.1",
    serverIp:
      "Bitte geben Sie serverIp ein, Formatreferenz: 1.1.1.1 oder Domänenname",
    successxml: "Datei erfolgreich geparst",
    groupCall: "Gruppenruf",
    groupCallTip:
      "Nach dem Einschalten können Sie alle Geräte in der Gruppe anrufen, indem Sie auf das Gruppenanrufsymbol klicken",
    record: "Versionsdatensatz",
    export: "Export",
    sync: "Synchronisieren",
    communityTip:
      "Aktuell gibt es Bereichsgerätedaten, Bereichsebene umschalten ist verboten",
    areaNameTitle: "Hierarchiebeschreibung",
    noDataTip: "Derzeit gibt es keine Daten",
    areaCodeDescriptionTip:
      "Die Gebietsbeschreibung kann nicht leer sein, bitte vollständig ausfüllen",
    moduleName: "Adressbuch-Konfigurationstool",
    userSipAccount:
      "Fixiert als Flächennummer der übergeordneten Gruppe+Gerätenummer",
    devMax:
      "Geräteknoten hat den Grenzwert von 10000 Einträgen überschritten, konnte nicht hinzugefügt werden",
    areaMax: "Area node exceeded the limit of 10000 entries, failed to add",
    ipAndMaskTip1:
      "Die IP-Adresse ist mit der Subnetzmaske verbunden und muss die Geschäftslogikvalidierung bestehen, um Ergebnisse mit allen 1en oder allen 0en nach der bitweisen UND-Operation zu haben.",
    ipAndMaskTip2:
      "Wenn ein Fehler bei der Geschäftsvalidierungsregel auftritt, ändern Sie bitte die entsprechende IP-Adresse.",
    ipAndMaskTip3:
      "Die Geschäftsvalidierungsregeln der Subnetzmaske und der IP-Adresse sind falsch. Bitte ändern Sie die IP-Adresse.",
    ipAndMaskTip4:
      "Beim Stapelhinzufügen von Geräten werden IPs, die die Geschäftslogikvalidierung nicht erfüllen, automatisch übersprungen.",
    correctMaskTip: "Bitte füllen Sie zuerst die korrekte Subnetzmaske aus.",
    correctIpTip: "Bitte geben Sie die korrekte IP-Adresse ein.",
  },
  newDeviceType: {
    indoorMachine: "Innenstation",
    doorPhone: "Türstation",
    smallDoor: "Kleine Türstation",
    manage: "Verwaltungsgerät",
    wall: "Mauergert",
    monitor: "IP-Kamera",
    unitGuard: "Verwaltungsgerät für die Einheit",
    networkCard: "Netzwerk-Kartlesegerät",
    unitCard: "Einheits-Kartlesegerät",
    lift: "Aufzug-Verknüpfungsmodul",
    deviceTypeTip: "Bitte wählen Sie den Gerätetyp aus"
    }
};
